import { ServicePartner } from '@models/index';

export class CustomerServicePartners {
	CustomerId!: string;
	CustomerName!: string;
	Updated = false;
	AssociatedServicePartners!: ServicePartner[];
}
